import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { CustomSeverityScope } from '../../../../shared/model-typings/customseverity';
import type {
  CreateCustomSeverityRequestBody,
  CustomSeverityResponse,
} from '../../../../shared/types/routes/customSeverities';

type CreateCustomRiskScoreVariables = {
  issueId: number;
  body: CreateCustomSeverityRequestBody;
  scope: {
    type: CustomSeverityScope;
    id: string;
  };
};

const createCustomRiskScore = ({ issueId, body, scope }: CreateCustomRiskScoreVariables) =>
  post<CreateCustomSeverityRequestBody, CustomSeverityResponse>(
    `/api/custom-risk-scores/${issueId}`,
    body,
    { query: { scope } },
  );

/**
 * Hook for creating a custom risk score on an issue.
 */
export default function useCreateCustomRiskScore() {
  return useToastedMutation({
    mutationFn: createCustomRiskScore,
    successToastMessage: 'Custom risk score assigned successfully',
    errorToastMessage: 'Failed to assign custom risk score',
  });
}
